import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1f15d6a6&scoped=true&"
import script from "./Notifications.js?vue&type=script&lang=js&"
export * from "./Notifications.js?vue&type=script&lang=js&"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=1f15d6a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15d6a6",
  null
  
)

export default component.exports